export const deploysConstants = {
    errors: {
        fetchFailed: "Failed to load deploys.",
        detailFailed: "Failed to load deploy.",
        createFailed: "Failed to upload deploy.",
        updateStatusFailed: "Failed to update status.",
        deleteFailed: "Failed to delete deploy.",
        downloadFailed: "Failed to download deploy.",
        genericError: "Something went wrong.",
    },
    messages: {
        createSuccess: "Deploy uploaded successfully.",
        updateStatusSuccess: "Deploy status updated.",
        deleteSuccess: "Deploy deleted.",
    },
};
